import { jwtDecode } from 'jwt-decode'

export const isTokenValid = (token: string): boolean => {
  try {
    const decoded = jwtDecode(token)
    if (!decoded.exp) return false

    const currentTime = Math.floor(Date.now() / 1000)

    return decoded.exp > currentTime
  } catch {
    return false
  }
}
